import { IPlanLoadStatusResponse } from '../../../modules/admin/types/adminSerffStatus.interface';
import { ADMIN_SERFF_PLAN_LOAD_STATUS_ACTION_TYPES } from '../../../constants/actionTypes/adminSerffStatusActionTypes';

interface IAction {
    type: string;
    payload?: any;
}

export const INITIAL_STATE = {
    planLoadStatusData: {
        content: [],
        pageable: {
            pageNumber: 0,
            pageSize: 10,
            sort: {
                sorted: false,
                unsorted: true,
                empty: true,
            },
            offset: 0,
            paged: true,
            unpaged: false,
        },
        totalPages: 0,
        totalElements: 0,
        last: false,
        numberOfElements: 0,
        size: 10,
        number: 0,
        sort: {
            sorted: false,
            unsorted: true,
            empty: true,
        },
        first: true,
        empty: true,
    },
    selectedFilters: {
        issuerFilter: '',
        typeFilter: '',
        statusFilter: '',
        dateFilter: '',
    },

};


export default (state = INITIAL_STATE, action: IAction) => {
    switch (action?.type) {
        case ADMIN_SERFF_PLAN_LOAD_STATUS_ACTION_TYPES.SET_PLAN_LOAD_STATUS_DATA: 
            return {
                ...state,
                planLoadStatusData: action.payload as IPlanLoadStatusResponse,
            };
        
        case ADMIN_SERFF_PLAN_LOAD_STATUS_ACTION_TYPES.SET_FILTERS: 
            return {
                ...state,
                selectedFilters: action.payload,
            };
        
        default:
            return state;
    }
};
